var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, Collection, ChildProperty } from '@syncfusion/ej2-base';
import { DayWorkingTime } from '../models/day-working-time';
/**
 * Represents a calendar exception that overrides default working time or marks non-working periods.
 *
 * Used to define one-off or recurring deviations from the standard calendar, such as holidays, adjusted work hours, or blackout dates.
 */
var CalendarException = /** @class */ (function (_super) {
    __extends(CalendarException, _super);
    function CalendarException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(null)
    ], CalendarException.prototype, "from", void 0);
    __decorate([
        Property(null)
    ], CalendarException.prototype, "to", void 0);
    __decorate([
        Property(null)
    ], CalendarException.prototype, "label", void 0);
    __decorate([
        Collection([], DayWorkingTime)
    ], CalendarException.prototype, "exceptionWorkingTime", void 0);
    return CalendarException;
}(ChildProperty));
export { CalendarException };
